const GET_USER_ROLES = 'GET_USER_ROLES'

export default GET_USER_ROLES
